import { render, staticRenderFns } from "./TestLogTable.vue?vue&type=template&id=e64f2df0&"
import script from "./TestLogTable.vue?vue&type=script&lang=js&"
export * from "./TestLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports